/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Caption_Track_PlaceholderInputs */

const en_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a caption track`)
};

const fr_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez une piste de sous-titres`)
};

const de_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Untertitelspur aus.`)
};

const it_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una traccia di sottotitoli`)
};

const ru_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите дорожку субтитров`)
};

const es_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar una pista de subtítulos`)
};

const zh_cn2_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择字幕轨道`)
};

const ja_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕トラックを選択`)
};

const hi_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन ट्रैक चुनें`)
};

const pt_pt2_embed_captions_caption_track_placeholder = /** @type {(inputs: Embed_Captions_Caption_Track_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma faixa de legenda.`)
};

/**
* | output |
* | --- |
* | "Select a caption track" |
*
* @param {Embed_Captions_Caption_Track_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_caption_track_placeholder = /** @type {((inputs?: Embed_Captions_Caption_Track_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Caption_Track_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_caption_track_placeholder(inputs)
	if (locale === "de") return de_embed_captions_caption_track_placeholder(inputs)
	if (locale === "it") return it_embed_captions_caption_track_placeholder(inputs)
	if (locale === "ru") return ru_embed_captions_caption_track_placeholder(inputs)
	if (locale === "es") return es_embed_captions_caption_track_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_caption_track_placeholder(inputs)
	if (locale === "ja") return ja_embed_captions_caption_track_placeholder(inputs)
	if (locale === "hi") return hi_embed_captions_caption_track_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_caption_track_placeholder(inputs)
	return en_embed_captions_caption_track_placeholder(inputs)
});